exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teksatir[data-v-5d029e94]{display:contents}", ""]);

// exports
